import React, { useState } from "react";
import { Container, Card } from "react-bootstrap";
import BioDataForm from "./BioDataForm";
import DocumentSubmissionForm from "./DocumentSubmissionForm";
import TestTab from "./TestTab"; // Import the TestTab component

const Application: React.FC = () => {
    const [activeForm, setActiveForm] = useState<"bio" | "document" | "test">("bio");

    const handleFormSelection = (form: "bio" | "document" | "test") => {
        setActiveForm(form);
    };

    const handleNext = () => {
        if (activeForm === "bio") {
            setActiveForm("document");
        } else if (activeForm === "document") {
            setActiveForm("test");
        }
    };

    return (
        <Container className="mt-5">
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h3>Application Page</h3>
            </div>
            <Card>
                <Card.Body>
                    <div className="row">
                        <div className="col-4">
                            <div 
                                className={`step-item border-top border-3 border-${activeForm === "bio" ? "success" : ""} pt-3`} 
                                onClick={() => handleFormSelection("bio")}
                            >
                                <input 
                                    type="radio" 
                                    name="step" 
                                    id="step1" 
                                    style={{ marginRight: "5px" }} 
                                    checked={activeForm === "bio"} 
                                    readOnly 
                                />
                                <label htmlFor="step1">Bio-data</label>
                            </div>
                        </div>
                        <div className="col-4">
                            <div 
                                className={`step-item border-top border-3 border-${activeForm === "document" ? "success" : ""} pt-3`} 
                                onClick={() => handleFormSelection("document")}
                            >
                                <input 
                                    type="radio" 
                                    name="step" 
                                    id="step2" 
                                    style={{ marginRight: "5px" }} 
                                    checked={activeForm === "document"} 
                                    readOnly 
                                />
                                <label htmlFor="step2">Documents</label>
                            </div>
                        </div>
                        <div className="col-4">
                            <div 
                                className={`step-item border-top border-3 border-${activeForm === "test" ? "success" : ""} pt-3`} 
                                onClick={() => handleFormSelection("test")}
                            >
                                <input 
                                    type="radio" 
                                    name="step" 
                                    id="step3" 
                                    style={{ marginRight: "5px" }} 
                                    checked={activeForm === "test"} 
                                    readOnly 
                                />
                                <label htmlFor="step3">Test</label>
                            </div>
                        </div>
                    </div>
                </Card.Body>
            </Card>
            <Card>
                <Card.Body>
                    {activeForm === "bio" && <BioDataForm onNext={handleNext} />}
                    {activeForm === "document" && <DocumentSubmissionForm />}
                    {activeForm === "test" && <TestTab />} {/* Render TestTab when activeForm is "test" */}
                </Card.Body>
            </Card>
        </Container>
    );
};

export default Application;
